import React from 'react';

import {
    Modal,
    Form,
    Input,
    Select,
    message,
    Spin,
    List,
    Button,
    Popconfirm,
    Card,
    Row,
    Radio,
    Popover,
    Divider,
} from 'antd'

import InfiniteScroll from 'react-infinite-scroller'
import debounce from 'debounce'

import {
    _postQbFindCustomers,
    _postQbCreateCustomer,
    _postQbSetBuyerId,
} from '../../services';

const { Search } = Input;
const RadioGroup = Radio.Group

class QuickbooksBuyerSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            refNumber: this.props.order.adminControls.offlineReferenceNumber,
            invalidRefNumber: "error",
            orderType: "online",
            data: false,
            setQbIdLoading: false,
            claimLoading: false,
            loading: false,
            hasMore: true,
            pageNumber: 0,
            searchTerm: '',
            quickbooksId: false,
            quickbooksDisplayName: false,
            qbCustomerNameType: "companyName"
        }

        this.handleSearch = debounce(this.handleSearch, 200);

    }

    componentDidMount() {

        _postQbFindCustomers(this.state.pageNumber, this.state.searchTerm)
            .then(res => {
                this.setState({ data: res.data.customers })
            })
            .catch(err => console.log(err))


        if (this.props.order.user.quickbooks && this.props.order.user.quickbooks.buyer) {
            this.setState({
                quickbooksId: this.props.order.user.quickbooks.buyer.id,
                quickbooksDisplayName: this.props.order.user.quickbooks.buyer.displayName
            })
        }


    }

    render() {

        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };

        return (
            <div>
                <Card
                    title={(<Search
                        onChange={this.handleOnSearchChange}
                        placeholder="Search company name"
                    // onSearch={this.handleOnSearch}
                    />)}
                >
                    <div
                        style={{
                            border: "1px solid #e8e8e8",
                            borderRadius: 4,
                            padding: "8px 24px",
                            height: 300,
                            overflow: "auto"
                        }}>
                        {this.state.data
                            ?
                            <InfiniteScroll
                                initialLoad={false}
                                pageStart={0}
                                loadMore={this.handleInfiniteOnLoad}
                                hasMore={!this.state.loading && this.state.hasMore}
                                useWindow={false}
                            >
                                <List
                                    dataSource={this.state.data}
                                    renderItem={item => (
                                        <Popconfirm
                                            title={<div><span>Link {item.DisplayName} to this customer?</span><br /><span>This cannot be undone.</span></div>}
                                            onConfirm={() => this.handleSetQuickbooksId(item.Id, item.DisplayName)}
                                            okText="Yes"
                                            cancelText="No">
                                            <List.Item
                                                style={{ cursor: "pointer" }}
                                                key={item.Id}>
                                                <div>{item.DisplayName}</div>
                                            </List.Item>
                                        </Popconfirm>
                                    )}
                                >
                                    {this.state.loading && this.state.hasMore && (
                                        <div style={{ textAlign: "center" }}>
                                            <Spin />
                                        </div>
                                    )}
                                </List>
                            </InfiniteScroll>

                            :
                            <div style={{ textAlign: "center" }}>
                                <Spin />
                            </div>
                        }
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <div>or</div>
                        <Popover
                            trigger="click"
                            title={<Row type="flex" justify="center">Use {this.props.order.user.details[this.state.qbCustomerNameType] || this.props.order.activeShipping[this.state.qbCustomerNameType]} for Quickbooks</Row>}
                            style={{ width: 250 }}
                            content={(
                                <Row>
                                    <Row>
                                        <RadioGroup onChange={this.handleOnChangeQbCustomerNameType} value={this.state.qbCustomerNameType}>
                                            <Radio style={radioStyle} value={"companyName"}>Company Name</Radio>
                                            <Radio style={radioStyle} value={"name"}>Buyer Name</Radio>
                                            <Radio style={radioStyle} value={"email"}>Email</Radio>
                                        </RadioGroup>
                                    </Row>
                                    <Row type="flex" justify="center">
                                        <Button type="primary" onClick={this.handleConfirmCreateCustomer}>Confirm</Button>
                                    </Row>
                                </Row>
                            )}
                        >
                            {this.state.setQbIdLoading ?
                                <Spin />
                                :
                                <Button>Create Quickbooks Customer</Button>
                            }
                        </Popover>
                    </div>
                </Card>
            </div>


        )




    }

    handleOnChangeQbCustomerNameType = (e) =>{
        this.setState({qbCustomerNameType:e.target.value})
    }
    

    handleOnSearchChange = (e) => {

        if (!e) {
            return
        } else {
            this.handleSearch(e.target.value)
        }
    }

    handleSearch = (searchTerm) => {

        this.setState({
            pageNumber: 0,
            searchTerm,
            hasMore: true,
            loading: true
        }, () => {
            _postQbFindCustomers(this.state.pageNumber, this.state.searchTerm)
                .then(res => {

                    if (res.data.customers.length === 0) {
                        message.warning("Loaded all customers")
                    }

                    this.setState({
                        data: res.data.customers,
                        loading: false
                    })
                })
        }
        )
    }

    handleInfiniteOnLoad = () => {

        let data = this.state.data;

        this.setState({
            loading: true,
            pageNumber: this.state.pageNumber + 1
        });

        _postQbFindCustomers(this.state.pageNumber, this.state.searchTerm)
            .then(res => {
                if (res.data.customers.length === 0) {
                    message.warning("Loaded all customers")
                    this.setState({
                        hasMore: false,
                        loading: false
                    })

                } else {
                    data = data.concat(res.data.customers)
                    this.setState({
                        data,
                        loading: false
                    })
                }
            })
    }

    handleSetQuickbooksId=(quickbooksId, quickbooksDisplayName)=>{

        this.setState({setQbIdLoading:true})

        _postQbSetBuyerId({
            quickbooksId, 
            quickbooksDisplayName, 
            cartId:this.props.order._id
        })
        .then( res => {

            this.setState({setQbIdLoading:false})

            if(res.data.success){
                this.setState({
                    quickbooksId:res.data.user.quickbooks.buyer.id,
                    quickbooksDisplayName: res.data.user.quickbooks.buyer.displayName
                },() => this.props.onConfirm(res.data.user))
                message.success("Quickbooks information assigned!")
            } else{
                console.log("Error", res.data.err)
                message.error("Error!")
            }
        })
    }

    handleConfirmCreateCustomer=()=>{   

        const { activeShipping, activeBilling } = this.props.order

        let type = this.state.qbCustomerNameType

        let qbCustomerName

        if (activeBilling){
            if( activeBilling.sameAsShipping ){
                qbCustomerName = activeShipping[type]
            } else {
                qbCustomerName = activeBilling[type]
            }
        } else {
            qbCustomerName = activeShipping[type]
        }

        _postQbCreateCustomer(this.props.order._id, qbCustomerName)
        .then( res => {
            if(res.data.success){
                let quickbooksId = res.data.quickbooks.buyer.id
                let quickbooksDisplayName = res.data.quickbooks.buyer.displayName
    
                this.handleSetQuickbooksId(quickbooksId, quickbooksDisplayName)
            } else{
                // console.log(res.data.err)
                message.error(res.data.err.Fault.Error[0].Message)
            }
        })
    }

}

export default QuickbooksBuyerSearch


// WEBPACK FOOTER //
// ./src/components/orders-v2/quickbooks-buyer-search.js